import React from "react";
import {
  StyledAvatar,
  StyledAvatarImage,
  StyledBadgeAvatar,
} from "./Avatar.styled";
import { FontWeightEnum } from "../../../types/AppTypes";
import { BodyTyp } from "../../Typography/Typography";
import { useAvatar } from "../../../hooks/useAvatar.hooks";

export enum AvatarDimensionsEnum {
  LARGE = "large",
  BIG = "big",
  SMALL = "small",
  X_SMALL = "x_small",
  XX_SMALL = "xx_small",
}

export enum AvatarDirectionEnum {
  VERTICAL = "vertical",
  HORIZONTAL = "horizontal",
}

type AvatarProps = {
  variant: AvatarDimensionsEnum;
  icon?: React.JSX.Element;
  initials: string;
  collaboratorId: number;
  withBorder?: boolean;
  badgeColor?: string;
};

export const Avatar = ({
  variant,
  icon,
  initials,
  collaboratorId,
  withBorder,
  badgeColor,
}: AvatarProps) => {
  if (collaboratorId < 0) return null;

  const { data: imageSrc } = useAvatar(collaboratorId);

  const initialsTypographyVariant =
    variant === AvatarDimensionsEnum.X_SMALL ? "3" : "2";
  const initialsFontWeight =
    variant === AvatarDimensionsEnum.X_SMALL
      ? FontWeightEnum.REGULAR
      : FontWeightEnum.SEMIBOLD;

  return (
    <StyledAvatar
      $withBorder={withBorder}
      $badgeColor={badgeColor}
      $variant={variant}
      className="avatar-container"
    >
      {imageSrc ? (
        <StyledAvatarImage src={imageSrc} alt={initials} />
      ) : (
        <BodyTyp
          fontWeight={initialsFontWeight}
          variant={initialsTypographyVariant}
        >
          {initials}
        </BodyTyp>
      )}
      {icon && (
        <StyledBadgeAvatar
          $withBorder={withBorder}
          $badgeColor={badgeColor}
          $variant={variant}
        >
          {icon}
        </StyledBadgeAvatar>
      )}
    </StyledAvatar>
  );
};
